import { throttle } from 'throttle-debounce';

export function init() {
    const mobileMenu = () => {
        let trigger = document.querySelector('.js-mobile-trigger');
        let menu = document.querySelector('.js-mobile-menu');
        let goBackLinks = document.querySelectorAll('.js-go-back');

        if (trigger) {
            trigger.addEventListener('click', (e) => {
                trigger.classList.toggle('nav-open');
                document.body.classList.toggle('state-fixed');
                menu.classList.toggle('nav-open');
                event.preventDefault();
            });
        }

        //when the window is resized if the menu is open shut it
        window.addEventListener(
            'resize',
            throttle(1000, () => {
                const mediaQuery = window.matchMedia('(min-width: 1024px)');
                if (mediaQuery.matches) {
                    trigger.classList.remove('nav-open');
                    document.body.classList.remove('state-fixed');
                    menu.classList.remove('nav-open');
                }
            })
        );

        goBackLinks.forEach((link) => {
            let parent = link.closest('.cl-mainmenu__item');
            let parentLink = parent.querySelector('.js-meganav-toggle');

            if (link) {
                link.addEventListener('click', (e) => {
                    parentLink.click(); // Trigger the click event directly on parentLink
                    e.preventDefault();
                });
            }
        });
    };

    const setupMegaMenu = () => {
        let megaMenuLinks = document.querySelectorAll('.js-meganav-toggle');

        if (!megaMenuLinks.length) {
            return;
        }

        megaMenuLinks.forEach((navLink) => {
            navLink.addEventListener('click', (e) => {
                megaMenuLinks.forEach((el) => {
                    if (e.target !== el) {
                        el.classList.remove('nav-open');
                        el.parentElement.classList.remove('state-nav-open');
                    }
                });
                navLink.classList.toggle('nav-open');
                navLink.parentElement.classList.toggle('state-nav-open');
                e.preventDefault();
            });
        });
    };

    const closeOnClickOutside = (navLink) => {
        document.addEventListener('click', (event) => {
            if (event.target.closest('.reveal-overlay')) {
                return; // Exit the function early if the target or its ancestor has the class
            }
            let megaMenuLinks = document.querySelectorAll('.js-meganav-toggle');

            megaMenuLinks.forEach((navLink) => {
                if (!navLink.parentElement.contains(event.target)) {
                    navLink.classList.remove('nav-open');
                    navLink.parentElement.classList.remove('state-nav-open');
                }
            });
        });
    };

    const setupSlidingTabs = () => {
        let slidingTabs = document.querySelectorAll('.js-sliding-tabs');

        if (!slidingTabs.length) {
            return;
        }

        function changeHandler(event) {
            let et = event.target;
            let parent = et.closest('.sliding-tabs');
            let ID = et.getAttribute('id');
            let contentDivs = parent.querySelectorAll('.sliding-tabs__content-body');

            contentDivs.forEach((div) => {
                div.classList.remove('state-visible');
            });

            document.getElementById(`tab-${ID}`).classList.add('state-visible');
        }

        slidingTabs.forEach((slidingTab) => {
            let radios = slidingTab.querySelectorAll('input[type="radio"]');

            radios.forEach((rad) => {
                if (rad) {
                    rad.addEventListener('change', changeHandler);
                }
            });
        });
    };

    const setupAnchorEventHandlers = () => {
        let anchorLinks = document.querySelectorAll('.meganav-list__link');

        for (let i = 0; i < anchorLinks.length; i++) {
            let linkUrl = anchorLinks[i].href;
            let linkPathname = linkUrl;
            let currentPathname = window.location.pathname;
            let screenSize = window.innerWidth;

            window.addEventListener('resize', () => {
                screenSize = window.innerWidth;
            });

            anchorLinks[i].addEventListener('click', () => {
                // console.log("Link Url = " + linkUrl);
                // console.log("Link Pathname = " + linkPathname);
                // console.log("Current Pathname = " + currentPathname);

                if (linkUrl.includes(currentPathname)) {
                    if (linkPathname.includes('.com/')) {
                        linkPathname = linkPathname.split('.com')[1];
                    }

                    if (linkPathname.includes('/#')) {
                        let megaMenuLinks = document.querySelectorAll('.js-meganav-toggle');
                        linkPathname = linkPathname.split('#')[0];

                        megaMenuLinks.forEach((navLink) => {
                            navLink.classList.remove('nav-open');
                            navLink.parentElement.classList.remove('state-nav-open');
                        });

                        if (screenSize < 1024) {
                            let mobileTriggerElement = document.querySelector('.js-mobile-trigger');

                            if (mobileTriggerElement) {
                                let clickEvent = new MouseEvent('click', {
                                    bubbles: true,
                                    cancelable: true,
                                    view: window,
                                });

                                mobileTriggerElement.dispatchEvent(clickEvent);
                            }
                        }
                    }

                    if (linkPathname === currentPathname) {
                        let megaMenuLinks = document.querySelectorAll('.js-meganav-toggle');
                        let mobileTrigger = document.querySelector('.js-mobile-trigger');
                        let mobileMenu = document.querySelector('.js-mobile-menu');

                        megaMenuLinks.forEach((navLink) => {
                            navLink.classList.remove('nav-open');
                            navLink.parentElement.classList.remove('state-nav-open');
                        });

                        if (screenSize < 1024) {
                            let mobileTriggerElement = document.querySelector('.js-mobile-trigger');

                            if (mobileTriggerElement) {
                                let clickEvent = new MouseEvent('click', {
                                    bubbles: true,
                                    cancelable: true,
                                    view: window,
                                });

                                mobileTriggerElement.dispatchEvent(clickEvent);
                            }
                        }
                    }
                }
            });
        }
    };

    setupMegaMenu();
    mobileMenu();
    setupSlidingTabs();
    closeOnClickOutside();
    setupAnchorEventHandlers();
}
